import request, { HttpMethod } from '@app/libs/request';
import config from '@app/config';
import { OrganizationServerResponse } from '@app/domain/userManagement/organizations';

export type OrganizationsSortCriteria = 'Name' | 'ServiceCount';
export type OrganizationsSortOrder = 'ASC' | 'DESC';

export interface SearchOrganizationsRequest {
  query?: string;
  serviceIds?: string[];
  sort: OrganizationsSortCriteria;
  order: OrganizationsSortOrder;
  offset: number;
  limit: number;
}

export async function searchOrganizations(
  params: SearchOrganizationsRequest,
  abortSignal: AbortSignal,
): Promise<PaginatedData<OrganizationServerResponse>> {
  return request<PaginatedData<OrganizationServerResponse>>(config.serverUrls.backee, `/api/organizations/search`, {
    method: HttpMethod.get,
    params,
    signal: abortSignal,
    errorsHandler: {
      default: {
        message: 'Cannot get organizations.',
      },
    },
  });
}
